// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  border-radius: 12px;
  overflow: hidden;
  display: block;
  overflow: hidden;
}

.filled {
  background-color: #f0f0f0;
  padding: 1rem;
  border: 1px solid transparent;
}

.elevada {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 1rem;
}

.outline {
  border: 1px solid #ccc;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/card/card.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,aAAA;EACA,6BAAA;AACJ;;AAEA;EACI,wCAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,sBAAA;EACA,aAAA;AACJ","sourcesContent":[".card {\n    border-radius: 12px; \n    overflow: hidden;   \n    display: block;\n    overflow: hidden;\n}\n\n.filled {\n    background-color: #f0f0f0; \n    padding: 1rem;\n    border: 1px solid transparent;\n}\n\n.elevada {\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n    background-color: white;\n    padding: 1rem;\n}\n\n.outline {\n    border: 1px solid #ccc;\n    padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
